import { useRef, useState, useCallback } from 'react';
import { COUNTRIES } from '../../utils/countries';
import useClickOutside from '../../hooks/useClickOutside';
import { IconChevron } from '../../components/icons';

/* Country dial-code dropdown for the phone field — same rich-select styling as
   the rest of the portal, with a type-to-filter search. */
export default function CountryCodePicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const ref = useRef(null);

  useClickOutside(ref, useCallback(() => setOpen(false), []));

  const q = query.trim().toLowerCase();
  const qDigits = q.replace(/\D/g, '');
  const filtered = q
    ? COUNTRIES.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.iso.toLowerCase() === q ||
          (qDigits.length > 0 && c.dial.startsWith(qDigits))
      )
    : COUNTRIES;

  const pick = (country) => {
    onChange(country);
    setOpen(false);
    setQuery('');
  };

  return (
    <div className="rich-select" style={{ flexShrink: 0 }} ref={ref}>
      <button
        type="button"
        className="rich-select-btn"
        style={{ width: 'auto', padding: '11px 10px' }}
        onClick={() => setOpen((o) => !o)}
      >
        <span>{value.flag}</span>
        <span style={{ fontWeight: 600 }}>+{value.dial}</span>
        <IconChevron />
      </button>
      {open && (
        <div className="rich-select-menu open" style={{ right: 'auto', width: 300 }}>
          <input
            type="text"
            value={query}
            placeholder="Search country or code"
            autoFocus
            style={{ marginBottom: 6, padding: '8px 10px', fontSize: 12.5 }}
            onChange={(e) => setQuery(e.target.value)}
          />
          <div style={{ maxHeight: 200, overflowY: 'auto' }}>
            {filtered.map((c) => (
              <div className="rich-select-item" key={c.iso + c.dial} onClick={() => pick(c)}>
                <span>{c.flag}</span>
                <span style={{ flex: 1 }}>{c.name}</span>
                <span style={{ color: 'var(--muted)' }}>+{c.dial}</span>
              </div>
            ))}
            {!filtered.length && (
              <div style={{ padding: '10px 9px', fontSize: 12.5, color: 'var(--muted)', textAlign: 'center' }}>
                No matches
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
